import { el } from "@/functions/el";
import { APP_ROUTES } from "../pages/APP_ROUTES";
import { customElement } from "./custom-element-decorator";
import { PjElement } from "./pj-element";

import "./pj-app-nav-element.css";

@customElement("pj-app-nav")
export class PjAppNavElement extends PjElement {
  readonly onNavigate = (): void => {
    this.querySelectorAll("a.active").forEach((e) => e.classList.remove("active"));
    this.querySelector(`a[href="${location.pathname}"]`)?.classList.add("active");
  };

  protected initialize(first: boolean): void | Promise<void> {
    if (first) {
      const nav = el("nav");
      this.replaceChildren(nav);

      for (const route of APP_ROUTES) {
        const a = el("a", { props: { href: route.pathName }, child: route.title });
        const li = el("li", { child: a });
        nav.append(li);
      }
    }

    document.addEventListener("spa.navigate", this.onNavigate, { signal: this.disconnected });
    this.onNavigate();
  }
}
